import React, { ComponentProps } from 'react';
import { StyleProp, ViewStyle, StyleSheet, TextStyle } from 'react-native';
import { Button as BaseButton } from 'exoflex';
import { IconSource } from 'react-native-paper';

import { BUTTON, TEXT } from '../constants/colors';

type ButtonMode = 'primary' | 'secondary' | 'invisible';

type ButtonProps = ComponentProps<typeof BaseButton>;
type Props = Omit<ButtonProps, 'children' | 'preset'> & {
  title: string;
  buttonMode?: ButtonMode;
  style?: StyleProp<ViewStyle>;
  icon?: IconSource;
  labelStyle?: StyleProp<TextStyle>;
};

export default function Button(props: Props) {
  let {
    title,
    color,
    style,
    labelStyle,
    icon,
    buttonMode = 'primary' as ButtonMode,
    disabled = false,
    ...otherProps
  } = props;

  return (
    <BaseButton
      preset={buttonMode}
      style={[styles.button, styles[buttonMode], style]}
      labelStyle={[
        styles.label,
        buttonMode === 'primary'
          ? styles.labelPrimary
          : styles.labelSecondaryInvisible,
        color ? { color } : null,
        labelStyle,
      ]}
      uppercase={false}
      disabled={disabled}
      icon={icon}
      {...otherProps}
    >
      {title}
    </BaseButton>
  );
}

const styles = StyleSheet.create({
  button: {
    justifyContent: 'center',
    maxHeight: 48,
    borderRadius: 8,
  },
  primary: {
    backgroundColor: BUTTON.default,
  },
  secondary: {
    borderColor: BUTTON.default,
  },
  invisible: {
    backgroundColor: 'transparent',
  },
  label: {
    fontSize: 16,
    letterSpacing: 0,
  },
  labelPrimary: {
    color: TEXT.white,
  },
  labelSecondaryInvisible: {
    color: TEXT.black,
  },
});
